import { createSlice } from '@reduxjs/toolkit';
import { currentUserDataFilter } from '../../helpers/users';
import {
  clearSaveStatus,
  clearUserData,
  closeProfileManagerDialog,
  initUserSession,
  setUserCurrentCompanyId,
  updateNotificationsPreference,
  openProfileManagerDialog,
  saveUserProfile,
  clearSaveUserProfileStatus,
  resendVerificationCode,
  clearVerificationCodeResent,
  verifyCode,
  openVerificationModal,
  getWorkOrderToPdf,
  setUserCurrentCompanyStatus,
} from '../actions/userManagementActions';

const initialState = {
  loading: false,
  userData: null,
  userState: false,
  userRoutes: '',
  currentUserRole: '',
  person: null,
  userRoles: [],
  saveSuccessful: null,
  showConfirmation: false,
  userCompanies: null,
  selectedUserCompanyId: null,
  selectedApproverRights: null,
  selectedDepartments: null,
  isLogIn: null,
  profileManagerDialogOpen: false,
  isSavingProfile: false,
  saveProfileStatus: null,
  verificationModalOpen: false,
  verificationCodeResent: false,
  verificationLoading: false,
  verificationStatus: null,
  owners: [],
  alternativeOwnerLoading: false,
  isLoadingPdf: false,
  dataPdf: null,
};

const userDataReducer = createSlice({
  name: 'userData',
  initialState,
  extraReducers: {
    [clearUserData.type]: () => ({ ...initialState }),
    [initUserSession.pending]: state => {
      state.loading = true;
    },
    [initUserSession.rejected]: state => {
      state.loading = false;
    },
    [initUserSession.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.person = payload.person;
      state.userData = payload.data;
      state.userState = true;
      state.userRoles = payload.userRoles;
      state.userRoutes = payload.routes;
      state.currentUserRole = payload.userRole;
      state.userCompanies = payload.companies;
      state.selectedUserCompanyId = payload.companyId;
      state.selectedApproverRights = payload.approverRights;
      state.selectedDepartments = payload.departments;
    },
    [updateNotificationsPreference.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.person = payload;
      state.saveSuccessful = true;
      state.showConfirmation = true;
    },
    [updateNotificationsPreference.rejected]: (state, { payload }) => {
      state.saveSuccessful = false;
      state.showConfirmation = true;
    },
    [clearSaveStatus.type]: (state, { payload }) => {
      state.showConfirmation = false;
    },
    [setUserCurrentCompanyId.type]: (state, { payload }) => {
      state.selectedUserCompanyId = payload;
      state.selectedApproverRights = currentUserDataFilter(
        payload,
        state.person.approverRights
      );
      state.selectedDepartments = currentUserDataFilter(
        payload,
        state.person.departments
      );
    },
    [setUserCurrentCompanyStatus.type]: (state, { payload }) => {
      state.userCurrentCompanyIdStatus = payload;
    },
    [openProfileManagerDialog.type]: state => {
      state.profileManagerDialogOpen = true;
      state.verificationModalOpen = false;
      state.verificationCodeResent = false;
      state.verificationLoading = false;
      state.verificationStatus = null;
      state.saveProfileStatus = null;
    },
    [closeProfileManagerDialog.type]: state => {
      state.profileManagerDialogOpen = false;
    },
    [saveUserProfile.pending]: (state, { meta: { arg } }) => {
      state.isSavingProfile = true;
    },
    [saveUserProfile.fulfilled]: (state, { payload }) => {
      state.isSavingProfile = false;
      state.profileManagerDialogOpen = false;
      state.person = payload.data;
      state.isLogIn = payload.isLogIn;
      state.saveProfileStatus = 'success';

      if (!payload.data.phoneVerifiedAt && !!payload.data.phone)
        state.verificationModalOpen = true;
    },
    [saveUserProfile.rejected]: state => {
      state.isSavingProfile = false;
      state.profileManagerDialogOpen = false;
      state.saveProfileStatus = 'error';
    },
    [clearSaveUserProfileStatus.type]: state => {
      state.saveProfileStatus = null;
      state.verificationModalOpen = false;
      state.verificationCodeResent = false;
      state.verificationLoading = false;
      state.verificationStatus = null;
      state.isLogIn = null;
    },
    [resendVerificationCode.fulfilled]: state => {
      state.verificationCodeResent = true;
      state.verificationStatus = null;
    },
    [clearVerificationCodeResent.type]: state => {
      state.verificationCodeResent = false;
    },
    [verifyCode.pending]: state => {
      state.verificationLoading = true;
      state.verificationStatus = null;
    },
    [verifyCode.fulfilled]: (state, { payload }) => {
      state.verificationLoading = false;
      state.verificationStatus = 'success';
      state.verificationModalOpen = false;
      state.person = payload;
    },
    [verifyCode.rejected]: state => {
      state.verificationLoading = false;
      state.verificationStatus = 'error';
    },

    [openVerificationModal.type]: state => {
      state.verificationModalOpen = true;
    },
    [getWorkOrderToPdf.pending]: state => {
      state.isLoadingPdf = true;
    },
    [getWorkOrderToPdf.fulfilled]: (state, { payload }) => {
      state.isLoadingPdf = false;
      state.dataPdf = payload;
    },
  },
});

export default userDataReducer;
